// @flow

import * as React from "react";

import correctness from "../../utils/correctness";

import type { UserTask } from "../../data/user-results";

import "./CorrectnessStats.css";

type Props = {
  tasks: Array<UserTask>
};

const CorrectnessStats = (props: Props) => {
  const stats = correctness.stats(props.tasks);
  const percentageString =
    stats.definite > 0
      ? `${(100 * stats.correct / stats.definite).toFixed(1)}%`
      : "?";
  return (
    <div className="CorrectnessStats">
      <p>
        Percentage of questions correct (in the right direction):{" "}
        <strong>{percentageString}</strong> ({stats.correct} of {stats.definite})
      </p>
      {stats.indefinite > 0 && (
        <p>
          This excludes {stats.indefinite} questions where you answered 50% or
          timed out.
        </p>
      )}
    </div>
  );
};

export default CorrectnessStats;



// WEBPACK FOOTER //
// ./src/components/CorrectnessStats/CorrectnessStats.js